var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomerHeaderBg = function SvgCustomerHeaderBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 720,
    height: 669,
    viewBox: "0 0 720 669",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "100%",
    x2: "13.918%",
    y1: "80.486%",
    y2: "25.987%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M369.639 37.128c-87.66 49.11-66.964 100.942-255.279 182.465-184.344 79.804-133.715 252.477 69.856 302.698C326.97 557.508 423.69 723.296 592.58 650.351c233.6-100.893 69.393-271.44 94.052-455.058C702.372 78.105 614.157.563 503.188.553 460.496.55 414.45 12.022 369.638 37.128"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "-32.228%",
    x2: "126.617%",
    y1: "12.92%",
    y2: "85.455%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "29.563%",
    x2: "78.82%",
    y1: "-58.435%",
    y2: "118.176%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9A5AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#48A2ED"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M14.165 299.564c-44.443 83.083 22.754 183.855 170.34 220.263C268.383 540.52 336.4 606.305 412.472 642.24c11.742-28.761 18.15-59.809 18.15-92.18 0-149.062-135.797-269.902-303.312-269.902-39.998 0-78.183 6.888-113.146 19.406",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M488.577-1.449c-54.299 48.77-87.832 115.874-87.832 189.95 0 149.064 135.796 269.903 303.309 269.903 4.99 0 9.95-.107 14.88-.32-7.417-79.828-44.697-170.812-32.015-265.255C702.66 75.641 614.444-1.9 503.475-1.909c-4.924 0-9.891.15-14.898.46",
    mask: "url(#d)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomerHeaderBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/customer-header-bg.3bfbe75c5531dc723f4addbc45fea0b1.svg";